import { createI18n } from 'vue-i18n';
import { getEnvVar } from '@/utils/env';
import numberFormat from './numberFormat';
import dateTimeFormats from './dateTimeFormats';
import messages from '@intlify/unplugin-vue-i18n/messages';
import { LANG_ENGLISH, LANG_FRENCH } from '@/constants';
import { getLocalStorage } from '@/service/core';

const environment = getEnvVar('VITE_SITE');

const location = window.location.href;

const getCurrentLang = () => {
  return location.split('/')?.includes(LANG_FRENCH) ? LANG_FRENCH : LANG_ENGLISH;
};

const i18n = createI18n({
  legacy: false,
  locale: environment === 'DEV' ? getLocalStorage('language') || LANG_ENGLISH : getCurrentLang(),
  fallbackLocale: getEnvVar('VITE_I18N_FALLBACK_LOCALE') || LANG_ENGLISH,
  globalInjection: true,
  allowComposition: true,
  messages
});
i18n.global.setNumberFormat(LANG_ENGLISH, numberFormat);
i18n.global.setNumberFormat(LANG_FRENCH, numberFormat);
i18n.global.setDateTimeFormat(LANG_ENGLISH, dateTimeFormats.en);
i18n.global.setDateTimeFormat(LANG_FRENCH, dateTimeFormats.fr);

export default i18n;

export function getLanguages(): string[] {
  return getEnvVar('VITE_I18N_LANGUAGES') ? getEnvVar('VITE_I18N_LANGUAGES').split(' ') : [LANG_ENGLISH];
}

export function getLanguageFromPath(path: string): string {
  const languages = getLanguages();

  for (const lang of languages) {
    if (path && new RegExp('/' + lang + '($|/)').test(path)) {
      return lang;
    }
  }

  return languages?.[0]?.length > 0 ? languages[0] : LANG_ENGLISH;
}

export function getCurrentLocationPath(): string {
  return window.location.pathname;
}

export function getCurrentLanguage(): string {
  return getLanguageFromPath(getCurrentLocationPath());
}

export function getCurrentLocale(): string {
  return i18n.global.locale.value;
}

export function setCurrentLocale(): void {
  i18n.global.locale.value = getCurrentLanguage();
}

export function setLocale(locale: string): void {
  const languages = getLanguages();
  if (languages && languages.indexOf(locale) > -1) {
    i18n.global.locale.value = locale;
  }
}
